module.exports = __webpack_public_path__ + "img/2019.ce274ac8.jpg";